import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showLoyaltyRedeem } from '../../utils';

class LoyaltyCard extends React.Component {
  renderSummary() {
    if (showLoyaltyRedeem() && this.props.new_member === false) {
      return (
        <div>
          {this.context.t('Your available Coins')}: {this.props.availableCoins - this.props.usedCoins}/{this.props.availableCoins}
        </div>
      );
    }
    return null;
  }

  render() {
    return (
            <div>
              <div className={this.props.name ? '' : 'hidden'}>{this.context.t('Hello')}, <b>{this.props.name}</b></div>
              {this.renderSummary()}
            </div>
    );
  }
}

LoyaltyCard.contextTypes = {
  t: PropTypes.func.isRequired,
};

LoyaltyCard.propTypes = {
  name: PropTypes.string,
  availableCoins: PropTypes.number,
  usedCoins: PropTypes.number,
};

export default connect()(LoyaltyCard);
